export const SYNC_DELETE = "SYNC_DELETE";
export const SYNC_ADD = "SYNC_ADD";
export const SYNC_UPDATE = "SYNC_UPDATE";
export const IDLE = "IDLE";
export const PENDING = "PENDING";
export const SYNC_KEY = 'sycnKey';

